import React, { useEffect, useState } from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import CateringContent from './CateringContent';
import CateringContentTwo from './CateringContentTwo';
import HomeContent from './HomeContent';
import CateringCards from './CateringCards';
import PageSEO from './PageSEO'; 

const spotlightArray = [
    {
      name: "Angelo",
      copyText: "When the BBQ's hot and the crowd's fed, smiles come easy, ask Angelo. He's a longtime Kinder's fan who was at an On-Site Catering event and the kind of guest who reminds us why we do what we do. Thanks, Angelo.",
      imageUrl: "/images/catering-happy-guest-angelo.webp"
    },
    {
      name: "Marina",
      copyText: "When the grill's going strong and the plates are cleared, we love seeing fans like Marina. She showed up hungry at an On-Site Catering event and left with a smile. The kind that makes this whole BBQ thing worth it. Thanks, Marina.",
      imageUrl: "/images/catering-happy-guest-marina.webp"
    },
    {
      name: "Greg",
      copyText: "From the smoky ribs to the last bite of Ball Tip, Greg knows what's good. He's a Kinder's regular who made our day at an On-Site Catering event. The kind of guy who reminds us this job is more than just cooking. Thanks, Greg.",
      imageUrl: "/images/catering-happy-guest-greg.webp"
    }
  ];

const CateringView = () => {

  const [selectedSpotlight, setSelectedSpotlight] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Random number generator: picks whole number between 1 and 3
    const randomNumber = Math.floor(Math.random() * 3) + 1;
    
    // Use random number to select from array (convert to 0-based index)
    const randomSpotlight = spotlightArray[randomNumber - 1];
    setSelectedSpotlight(randomSpotlight);
  }, []);

  // Comprehensive SEO configuration for catering page
  const cateringSEO = {
    title: "Catering | Kinder's Meats Deli BBQ & Catering - Legendary BBQ for Your Event",
    description: "Kinder's Meats BBQ catering brings authentic barbecue to your event. From corporate functions to weddings, we serve legendary BBQ, pickup, delivery, and on-site catering across 7 California locations.",
    keywords: [
      "Kinder's Meats catering",
      "BBQ catering California",
      "authentic BBQ catering",
      "corporate BBQ catering",
      "wedding BBQ catering",
      "event BBQ catering",
      "East Bay BBQ catering",
      "BBQ catering Bay Area",
      "catering Concord",
      "catering Brentwood", 
      "catering Martinez",
      "catering Pleasant Hill",
      "catering Walnut Creek",
      "catering Hercules",
      "Ball Tip Sandwich catering",
      "smoked ribs catering",
      "BBQ pickup catering",
      "BBQ delivery catering",
      "on-site BBQ catering",
      "large event catering",
      "corporate lunch catering",
      "party BBQ catering",
      "office catering BBQ",
      "BBQ buffet catering",
      "California BBQ catering services",
      "butcher counter catering",
      "marinated meats catering"
    ],
    canonicalUrl: "/catering",
    ogImage: "https://kindersmeats.com/images/catering-hero-og.jpg",
    customMeta: {
      'service:type': 'BBQ Catering Services',
      'service:cuisine': 'BBQ, American, Deli',
      'service:area': 'California Bay Area',
      'service:delivery': 'Pickup, Delivery, On-site'
    },
    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Service",
          "@id": "https://kindersmeats.com/catering#service",
          "name": "Kinder's Meats BBQ Catering Services",
          "description": "Professional BBQ catering services featuring authentic barbecue, signature Ball Tip Sandwiches, and full-service event catering across California.",
          "url": "https://kindersmeats.com/catering",
          "provider": {
            "@id": "https://kindersmeats.com/#organization"
          },
          "serviceType": "BBQ Catering",
          "areaServed": [
            {
              "@type": "City",
              "name": "Concord",
              "addressRegion": "CA"
            },
            {
              "@type": "City", 
              "name": "Walnut Creek",
              "addressRegion": "CA"
            },
            {
              "@type": "City",
              "name": "Pleasant Hill", 
              "addressRegion": "CA"
            },
            {
              "@type": "City",
              "name": "Martinez",
              "addressRegion": "CA"
            },
            {
              "@type": "City",
              "name": "Brentwood",
              "addressRegion": "CA"
            },
            {
              "@type": "City",
              "name": "Hercules",
              "addressRegion": "CA"
            }
          ],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "BBQ Catering Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Pickup Catering",
                  "description": "Order ahead and pickup your BBQ catering order at any Kinder's location"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service", 
                  "name": "Delivery Catering",
                  "description": "BBQ catering delivered to your event location"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "On-Site Catering",
                  "description": "Full-service on-site BBQ catering with setup and service"
                }
              }
            ]
          },
          "audience": {
            "@type": "Audience",
            "audienceType": ["Corporate Events", "Weddings", "Private Parties", "Large Groups"]
          }
        },
        {
          "@type": "Organization",
          "@id": "https://kindersmeats.com/#organization",
          "name": "Kinder's Meats Deli BBQ & Catering",
          "url": "https://kindersmeats.com",
          "logo": "https://kindersmeats.com/images/kinders-logo.png",
          "sameAs": [
            "https://www.facebook.com/KindersMeats",
            "https://www.instagram.com/kindersmeats", 
            "https://www.yelp.com/biz/kinders-meats"
          ],
          "description": "Family-owned BBQ restaurant and catering company serving authentic barbecue since 1946 across 7 California locations.",
          "foundingDate": "1946",
          "numberOfEmployees": "50-100",
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "catering sales",
            "telephone": "(925) 676-1661"
          },
          "makesOffer": {
            "@id": "https://kindersmeats.com/catering#service"
          }
        },
        {
          "@type": "WebPage",
          "@id": "https://kindersmeats.com/catering#webpage",
          "url": "https://kindersmeats.com/catering",
          "name": "Catering | Kinder's Meats Deli BBQ & Catering - Legendary BBQ for Your Event",
          "description": "Kinder's Meats BBQ catering brings authentic barbecue to your event. From corporate functions to weddings, we serve legendary BBQ with pickup, delivery, and on-site services.",
          "isPartOf": {
            "@id": "https://kindersmeats.com/#website"
          },
          "about": {
            "@id": "https://kindersmeats.com/catering#service"
          },
          "mainEntity": {
            "@id": "https://kindersmeats.com/catering#service"
          },
          "breadcrumb": {
            "@id": "https://kindersmeats.com/catering#breadcrumb"
          }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://kindersmeats.com/catering#breadcrumb",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home", 
              "item": "https://kindersmeats.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Catering",
              "item": "https://kindersmeats.com/catering"
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What catering services does Kinder's Meats offer?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Kinder's Meats offers three catering options: pickup catering where you order ahead and pickup at any location, delivery catering brought to your event, and full-service on-site catering with setup and service for larger events."
              }
            },
            {
              "@type": "Question",
              "name": "What areas do you provide catering service to?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide BBQ catering services throughout the California Bay Area, including Concord, Walnut Creek, Pleasant Hill, Martinez, Brentwood, Hercules, and surrounding communities."
              }
            },
            {
              "@type": "Question",
              "name": "What's included in Kinder's BBQ catering menu?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Our catering menu features our signature Ball Tip Sandwich, slow-smoked ribs, pulled pork, brisket, marinated chicken, plus deli sandwiches, fresh sides like BBQ beans and coleslaw, and items from our butcher counter."
              }
            },
            {
              "@type": "Question",
              "name": "How far in advance should I order catering?",
              "acceptedAnswer": {
                "@type": "Answer", 
                "text": "We recommend ordering catering at least 48-72 hours in advance for pickup and delivery orders. For large on-site events, we suggest 1-2 weeks advance notice to ensure availability and proper planning."
              }
            },
            {
              "@type": "Question",
              "name": "Can Kinder's cater large events?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! We've catered events for groups ranging from 15 people to over 10,000 guests. Our experienced team can handle corporate events, weddings, festivals, and large gatherings with full-service on-site catering."
              }
            },
            {
              "@type": "Question",
              "name": "How do I get a catering quote?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "You can request a catering quote by contacting any of our 7 locations directly, visiting our website's catering request form, or calling our catering team. We'll work with you to customize a menu that fits your event and budget."
              }
            }
          ]
        }
      ]
    }
  };

  // Show loading or return early if no spotlight selected yet
  if (!selectedSpotlight) {
    return null;
  }

  return (
    <>
      {/* SEO Component */}
      <PageSEO {...cateringSEO} />
      
      {/* Main content with semantic HTML structure */}
      <main>
        <section className="theme-light section m-0 p-0" data-theme="light">
          <div className='is-flex is-flex-direction-column is-justify-content-start'>
            <Navigation 
              colorMode="colorBlack"
            />
            
            {/* Hero Section with Background Image */}
            <CateringContent 
                title="Kinder's Catering"
                subtitle="Legendary BBQ. Served your way."
                imageUrl="/images/catering-hero.webp"
                imageMobileUrl="/images/catering-hero-mobile.webp"
            />
            
            <CateringContentTwo 
                subtitle="Pick it up, get it delivered or go big. We've got you."
                body="Whether it's 15 coworkers or 10,000 hungry guests (seriously, we've done that!), Kinder's shows up with bold, smoky flavors and the down-to-earth craft of a neighborhood butcher and BBQ smokehouse."
            />

            {/* Three Catering Cards */}
            <CateringCards />

            {/* First Copy Block - Image Left, Text Right */}
            <HomeContent 
                imageUrl="/images/catering-pitmaster.webp"
                imageAlt="Meet Your Pitmaster"
                headline="Meet Your Pitmaster"
                copyText="Ryan's got smoke in his veins. He sticks to applewood, keeps a steady hand on the fire, and knows when the meat is just right. Ask him how he tells, and he’ll just grin and say, 'You just know.'"
                reversed={false}
                colorMode="colorBlack"
                buttonLabel="Request Quote"
                buttonUrl="/catering/request-quote"
            />

            {/* Spacer between blocks */}
            <div className="py-6"></div>

            {/* Second Copy Block - Randomly Selected Happy Guest */}
            <HomeContent 
                imageUrl={selectedSpotlight.imageUrl}
                imageAlt={`Meet A Happy Guest - ${selectedSpotlight.name}`}
                headline="Meet A Happy Guest"
                copyText={selectedSpotlight.copyText}
                reversed={true}
                colorMode="colorBlack"
                buttonLabel="Request Quote"
                buttonUrl="/catering/request-quote"
            />

            {/* Hidden FAQ Section for SEO */}
            <section className="faq-section" style={{ display: 'none' }} aria-hidden="true" itemScope itemType="https://schema.org/FAQPage">
              <h2>Catering FAQ</h2>
              
              <div itemScope itemType="https://schema.org/Question">
                <h3 itemProp="name">What catering services does Kinder's Meats offer?</h3>
                <div itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
                  <div itemProp="text">
                    Kinder's Meats offers three catering options: pickup catering where you order ahead and pickup at any location, delivery catering brought to your event, and full-service on-site catering with setup and service for larger events.
                  </div>
                </div>
              </div>

              <div itemScope itemType="https://schema.org/Question">
                <h3 itemProp="name">What areas do you provide catering service to?</h3>
                <div itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
                  <div itemProp="text">
                    We provide BBQ catering services throughout the California Bay Area, including Concord, Walnut Creek, Pleasant Hill, Martinez, Brentwood, Hercules, and surrounding communities.
                  </div>
                </div>
              </div>

              <div itemScope itemType="https://schema.org/Question">
                <h3 itemProp="name">What's included in Kinder's BBQ catering menu?</h3>
                <div itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
                  <div itemProp="text">
                    Our catering menu features our signature Ball Tip Sandwich, slow-smoked ribs, pulled pork, brisket, marinated chicken, plus deli sandwiches, fresh sides like BBQ beans and coleslaw, and items from our butcher counter.
                  </div>
                </div>
              </div>
            </section>

            <Footer />
          </div>
        </section>
      </main>
    </>
  );
};

export default CateringView;